
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Box,
  TextField,
  TablePagination,
  TableSortLabel,
  InputAdornment,
  Button,
  useTheme,
  alpha,
  styled,
  Menu,
  Chip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  Tooltip,
   Grid,
  Card,
  CardMedia,
  CardContent,
 CardActions,
} from '@mui/material';
import logoUrl from '../logo.jpeg'
import {
  Search as SearchIcon,
  Refresh as RefreshIcon,
  ErrorOutline as ErrorOutlineIcon,
  FileDownload as FileDownloadIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  CalendarToday as CalendarTodayIcon,
  Close as CloseIcon,
  Image as ImageIcon,
  Description as DescriptionIcon,
  Attachment as AttachmentIcon,
    Download as DownloadIcon,
   ZoomIn as ZoomInIcon
} from '@mui/icons-material';
import baseUrl from '../Config';
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
import { jsPDF } from "jspdf";
import ContactMailIcon from '@mui/icons-material/ContactMail';
import SchoolIcon from '@mui/icons-material/School';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CheckIcon from '@mui/icons-material/Check';
import PersonIcon from '@mui/icons-material/Person';


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: alpha('#4BB648', 0.03),
  },
  '&:hover': {
    backgroundColor: alpha('#4BB648', 0.08),
  },
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: alpha('#4BB648', 0.12),
  },
}));

const GreenChip = styled(Chip)(({ theme }) => ({
  backgroundColor: alpha('#4BB648', 0.1),
  color: '#4BB648',
  fontWeight: 500,
  '& .MuiChip-label': {
    padding: '0 8px',
  },
}));

const getStatusColor = (status) => {
  if (!status) return '#9e9e9e';
  
  const statusColors = {
    'paid fees': '#4caf50',
    'class going on': '#2196f3',
    'finished': '#ff9800',
    'waiting for review application': '#9c27b0',
    'dataflow on process': '#ff9800',
    'completed / discrepancy': '#f44336',
    'waiting for booking': '#00bcd4',
    'exam booked': '#4caf50',
    'credential applied': '#2196f3',
    'eligibility letter applied': '#4caf50',
    'evaluation applied': '#ff9800',
    'exam pass - successfully completed': '#4caf50',
    'discontinued': '#f44336',
    'exam fail': '#f44336'
  };
  
  return statusColors[status] || '#9e9e9e';
};

const ExportDialog = ({ open, onClose, onExport }) => {
  const [exportType, setExportType] = useState('dateRange');
  const [customDays, setCustomDays] = useState(7);

  const handleExport = () => {
    if (exportType === 'dateRange') {
      onExport(customDays);
    } else {
      onExport('all');
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ 
        bgcolor: '#4BB648', 
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <FileDownloadIcon />
        Export Candidates
      </DialogTitle>
      <DialogContent sx={{ pt: 7, pb: 2 }}>
        <Box sx={{paddingTop:'20px'}}>
  <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel>Export Type</InputLabel>
          <Select
            value={exportType}
            onChange={(e) => setExportType(e.target.value)}
            label="Export Type"

          >
            <MenuItem value="dateRange">By Date Range</MenuItem>
            <MenuItem value="all">All Candidates</MenuItem>
          </Select>
        </FormControl>
        </Box>
      

        {exportType === 'dateRange' && (
          <TextField
            fullWidth
            label="Last X Days"
            type="number"
            value={customDays}
            onChange={(e) => setCustomDays(Math.max(1, e.target.value))}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarTodayIcon color="action" />
                </InputAdornment>
              ),
              inputProps: { min: 1 }
            }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose} 
          sx={{ color: 'text.secondary', mr: 1 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleExport}
          variant="contained"
          sx={{
            bgcolor: '#4BB648',
            '&:hover': { bgcolor: '#3D8B3A' }
          }}
          startIcon={<FileDownloadIcon />}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CandidateList = () => {
const theme = useTheme();
const [candidates, setCandidates] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState('');
const [searchTerm, setSearchTerm] = useState('');
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);
const [order, setOrder] = useState('desc');
const [orderBy, setOrderBy] = useState('createdAt');
const [selectedCandidate, setSelectedCandidate] = useState(null);
const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
const [exportDialogOpen, setExportDialogOpen] = useState(false);
const [anchorEl, setAnchorEl] = useState(null);
const [viewDialogOpen, setViewDialogOpen] = useState(false);
const [attachmentDialogOpen, setAttachmentDialogOpen] = useState(false);
const [selectedAttachments, setSelectedAttachments] = useState([]);
const [previewAttachment, setPreviewAttachment] = useState(null);
const [previewOpen, setPreviewOpen] = useState(false);
const [selectedPeriod, setSelectedPeriod] = useState('all');
const [selectedStatus, setSelectedStatus] = useState('all');
const [periodTotals, setPeriodTotals] = useState({
    today: 0,
    yesterday: 0,
    thisWeek: 0,
    lastWeek: 0,
    thisMonth: 0,
    lastMonth: 0,
    thisYear: 0,
    all: 0
  });


  // Update the status groups to match your form's structure
const statusGroups = {
  "online class": ["paid fees", "class going on", "finished"],
  dataflow: ["waiting for review application", "dataflow on process", "completed / discrepancy"],
  "exam booking": ["waiting for booking", "exam booked"],
  others: ["credential applied", "eligibility letter applied", "evaluation applied", "payment MD response"],
  "final step": ["exam pass - successfully completed", "discontinued", "exam fail"],
};
  const fetchCandidates = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(`${baseUrl}/candidates`);

      const data = response.data;

      console.log('Fetched candidates data11111111111111111:', data);    
  
   const transformedData = data.map(candidate => {
    const first = parseFloat(candidate.first_installment_paid || 0);
    const second = parseFloat(candidate.second_installment_paid || 0);
    const third = parseFloat(candidate.third_installment_paid || 0);
    const fourth = parseFloat(candidate.fourth_installment_paid || 0);

    return {
      _id: candidate.id,
      registrationNumber: candidate.registration_number,
      candidateName: `${candidate.candidate_first_name} ${candidate.candidate_last_name}`,
      candidateFirstName: `${candidate.candidate_first_name}`,
      candidateLastName: ` ${candidate.candidate_last_name}`,
      officialEmail: candidate.official_email,
      phoneNo: candidate.phone_no,
      whatsappNo: candidate.whatsapp_no,
      dateOfBirth: candidate.date_of_birth,
      gender: candidate.gender,
      pancard: candidate.pancard,
      passportNumber: candidate.passport_number,
      passportIssueDate: candidate.passport_issue_date,
      passportExpiryDate: candidate.passport_expiry_date,
      educationCategory: candidate.education_category,
      professionalCategory: candidate.professional_category,
      licenseCategory: candidate.license_category,
      totalProcessingFees: candidate.total_processing_fees,
      firstInstallmentPaid: first,
      firstInstallmentDate: candidate.first_installment_date,
      secondInstallmentPaid: second,
      secondInstallmentDate: candidate.second_installment_date,
      thirdInstallmentPaid: third,
      thirdInstallmentDate: candidate.third_installment_date,
      fourthInstallmentPaid: fourth,
      totalPaid: first + second + third + fourth,
      balance: candidate.balance,
      licenseProcessedBy: candidate.license_processed_by,
      registeredBy: candidate.registered_by,
      createdAt: candidate.created_at,
      updatedAt: candidate.updated_at,
      remarks: candidate.remarks,
      referredBy: candidate.referred_by,
      profileImage: candidate.profile_image,
      attachments: candidate.attachments,
      status: candidate.status // Add this line
    };
  });
      setCandidates(transformedData);
      calculatePeriodTotals(transformedData);
    } catch (err) {
      setError('Failed to fetch candidates. Please try again.');
      console.error('Error fetching candidates:', err);
    } finally {
      setLoading(false);
    }
  };


 // Calculate period-based totals
  const calculatePeriodTotals = (candidatesData) => {
    const now = dayjs();
    const todayStart = now.startOf('day');
    const yesterdayStart = now.subtract(1, 'day').startOf('day');
    const thisWeekStart = now.startOf('week');
    const lastWeekStart = now.subtract(1, 'week').startOf('week');
    const lastWeekEnd = lastWeekStart.endOf('week');
    const thisMonthStart = now.startOf('month');
    const lastMonthStart = now.subtract(1, 'month').startOf('month');
    const lastMonthEnd = lastMonthStart.endOf('month');
    const thisYearStart = now.startOf('year');

    const totals = {
      today: 0,
      yesterday: 0,
      thisWeek: 0,
      lastWeek: 0,
      thisMonth: 0,
      lastMonth: 0,
      thisYear: 0,
      all: 0
    };

    candidatesData.forEach(candidate => {
      const createdDate = dayjs(candidate.createdAt);
      const paidAmount = candidate.totalPaid || 0;
      
      // Add to all total
      totals.all += paidAmount;
      
      // Check and add to period totals
      if (createdDate.isAfter(todayStart)) {
        totals.today += paidAmount;
      }
      
      if (createdDate.isAfter(yesterdayStart) && createdDate.isBefore(todayStart)) {
        totals.yesterday += paidAmount;
      }
      
      if (createdDate.isAfter(thisWeekStart)) {
        totals.thisWeek += paidAmount;
      }
      
      if (createdDate.isAfter(lastWeekStart) && createdDate.isBefore(lastWeekEnd)) {
        totals.lastWeek += paidAmount;
      }
      
      if (createdDate.isAfter(thisMonthStart)) {
        totals.thisMonth += paidAmount;
      }
      
      if (createdDate.isAfter(lastMonthStart) && createdDate.isBefore(lastMonthEnd)) {
        totals.lastMonth += paidAmount;
      }
      
      if (createdDate.isAfter(thisYearStart)) {
        totals.thisYear += paidAmount;
      }
    });

    setPeriodTotals(totals);
  };

  useEffect(() => {
    fetchCandidates();
  }, []);

   // Filter candidates based on selected period
  const filterCandidatesByPeriod = (candidatesData) => {
    const now = dayjs();
    
    switch (selectedPeriod) {
      case 'today':
        const todayStart = now.startOf('day');
        return candidatesData.filter(candidate => 
          dayjs(candidate.createdAt).isAfter(todayStart)
        );
      
      case 'yesterday':
        const yesterdayStart = now.subtract(1, 'day').startOf('day');
        const yesterdayEnd = now.subtract(1, 'day').endOf('day');
        return candidatesData.filter(candidate => {
          const createdDate = dayjs(candidate.createdAt);
          return createdDate.isAfter(yesterdayStart) && createdDate.isBefore(yesterdayEnd);
        });
      
      case 'thisWeek':
        const weekStart = now.startOf('week');
        return candidatesData.filter(candidate => 
          dayjs(candidate.createdAt).isAfter(weekStart)
        );
      
      case 'lastWeek':
        const lastWeekStart = now.subtract(1, 'week').startOf('week');
        const lastWeekEnd = now.subtract(1, 'week').endOf('week');
        return candidatesData.filter(candidate => {
          const createdDate = dayjs(candidate.createdAt);
          return createdDate.isAfter(lastWeekStart) && createdDate.isBefore(lastWeekEnd);
        });
      
      case 'thisMonth':
        const monthStart = now.startOf('month');
        return candidatesData.filter(candidate => 
          dayjs(candidate.createdAt).isAfter(monthStart)
        );
      
      case 'lastMonth':
        const lastMonthStart = now.subtract(1, 'month').startOf('month');
        const lastMonthEnd = now.subtract(1, 'month').endOf('month');
        return candidatesData.filter(candidate => {
          const createdDate = dayjs(candidate.createdAt);
          return createdDate.isAfter(lastMonthStart) && createdDate.isBefore(lastMonthEnd);
        });
      
      case 'thisYear':
        const yearStart = now.startOf('year');
        return candidatesData.filter(candidate => 
          dayjs(candidate.createdAt).isAfter(yearStart)
        );
      
      default:
        return candidatesData;
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

const handleViewDetails = () => {
  setViewDialogOpen(true);  
  setAnchorEl(null);        
};

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleMenuClick = (event, candidate) => {
    setAnchorEl(event.currentTarget);
    setSelectedCandidate(candidate);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedCandidate(null);
  };



const handlePreviewAttachment = (attachment) => {
  setPreviewAttachment(attachment);
  setPreviewOpen(true);
};

const handleClosePreview = () => {
  setPreviewOpen(false);
  setPreviewAttachment(null);
};

const handleCloseAttachmentDialog = () => {
  setAttachmentDialogOpen(false);
  setSelectedAttachments([]);
};

const handleEditCandidate = () => {
  if (selectedCandidate) {
    const candidateId = selectedCandidate.id || selectedCandidate._id;
    const url = `/candidate-form/${candidateId}?action=edit`;
    window.open(url, '_blank'); // Opens URL in a new tab
  }
  handleMenuClose();
};




  const handleDeleteClick = (candidate) => {
  setSelectedCandidate(candidate);  
  setDeleteDialogOpen(true);
  // handleMenuClose();
   };

  const handleDeleteConfirm = async () => {
    if (selectedCandidate) {
      try {
        await axios.delete(`${baseUrl}/candidate/${selectedCandidate._id}`);
        fetchCandidates();
      } catch (err) {
        console.error('Error deleting candidate:', err);
        setError('Failed to delete candidate');
      }
    }
    setDeleteDialogOpen(false);
    handleMenuClose();
  };
  // Export functions
  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const handleExport = (days) => {
    if (days === 'all') {
      exportFormattedData(candidates, 'all_candidates');
    } else {
      const cutoffDate = dayjs().subtract(days, 'day').toDate();
      const filteredData = candidates.filter(candidate => 
        dayjs(candidate.createdAt).isAfter(cutoffDate)
      );
      exportFormattedData(filteredData, `candidates_last_${days}_days`);
    }
  };

  // const exportFormattedData = (data, fileName) => {
  //   const formattedData = data.map(candidate => ({
  //     'Registration No': candidate.registrationNumber,
  //     // 'Name': candidate.candidateName,
  //     'First Name': candidate.candidateFirstName,
  //     'Last Name': candidate.candidateLastName,
  //     'Date of Birth': formatDate(candidate.dateOfBirth),
  //     'Gender': candidate.gender,
  //     'Email': candidate.officialEmail,
  //     'Phone': candidate.phoneNo,
  //     'WhatsApp': candidate.whatsappNo,
  //     'Passport No': candidate.passportNumber,
  //     'Passport Issue': formatDate(candidate.passportIssueDate),
  //     'Passport Expiry': formatDate(candidate.passportExpiryDate),
  //     'Education': candidate.educationCategory,
  //     'Professional Category': candidate.professionalCategory,
  //     'License': candidate.licenseCategory,
  //     'Total Fees': candidate.totalProcessingFees,
  //     '1st Installment': candidate.firstInstallmentPaid,
  //     '1st Installment Date': formatDate(candidate.firstInstallmentDate),
  //     '2nd Installment': candidate.secondInstallmentPaid,
  //     '2nd Installment Date': formatDate(candidate.secondInstallmentDate),
  //     '3rd Installment': candidate.thirdInstallmentPaid,
  //     '3rd Installment Date': formatDate(candidate.thirdInstallmentDate),
  //     'Total Paid': candidate.totalPaid,
  //     'Balance': candidate.balance,
  //     'Processed By': candidate.licenseProcessedBy,
  //     'Registered By': candidate.registeredBy,
  //     'Registration Date': formatDate(candidate.createdAt),
  //     'Updated At': formatDate(candidate.updatedAt),
  //     'Remarks': candidate.remarks,
  //     'Referred By': candidate.referredBy,
  //     'Profile Image': candidate.profileImage,
  //     'Attachments': candidate.attachments ? candidate.attachments.join(', ') : '',
  //   }));
  //   exportToExcel(formattedData, fileName);
  // };

 // Update the exportFormattedData function to include status
const exportFormattedData = (data, fileName) => {
  const formattedData = data.map(candidate => ({
    'Registration No': candidate.registrationNumber,
    'First Name': candidate.candidateFirstName,
    'Last Name': candidate.candidateLastName,
    'Status': candidate.status, // Add this line
    'Date of Birth': formatDate(candidate.dateOfBirth),
    'Gender': candidate.gender,
    'Email': candidate.officialEmail,
    'Phone': candidate.phoneNo,
    'WhatsApp': candidate.whatsappNo,
    'Passport No': candidate.passportNumber,
    'Passport Issue': formatDate(candidate.passportIssueDate),
    'Passport Expiry': formatDate(candidate.passportExpiryDate),
    'Education': candidate.educationCategory,
    'Professional Category': candidate.professionalCategory,
    'License': candidate.licenseCategory,
    'Total Fees': candidate.totalProcessingFees,
    '1st Installment': candidate.firstInstallmentPaid,
    '1st Installment Date': formatDate(candidate.firstInstallmentDate),
    '2nd Installment': candidate.secondInstallmentPaid,
    '2nd Installment Date': formatDate(candidate.secondInstallmentDate),
    '3rd Installment': candidate.thirdInstallmentPaid,
    '3rd Installment Date': formatDate(candidate.thirdInstallmentDate),
    'Total Paid': candidate.totalPaid,
    'Balance': candidate.balance,
    'Processed By': candidate.licenseProcessedBy,
    'Registered By': candidate.registeredBy,
    'Registration Date': formatDate(candidate.createdAt),
    'Updated At': formatDate(candidate.updatedAt),
    'Remarks': candidate.remarks,
    'Referred By': candidate.referredBy,
    'Profile Image': candidate.profileImage,
    'Attachments': candidate.attachments ? candidate.attachments.join(', ') : '',
  }));
  exportToExcel(formattedData, fileName);
};
  
  const formatDate = (dateString) => {
    return dateString ? dayjs(dateString).format('DD-MMM-YYYY') : '';
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  const getInitials = (name) => {
    if (!name) return '';
    return name.split(' ').map(part => part[0]).join('').toUpperCase();
  };

  
// Flatten all statuses for the filter dropdown
const allStatuses = [
  ...statusGroups["online class"],
  ...statusGroups["dataflow"],
  ...statusGroups["exam booking"],
  ...statusGroups["others"],
  ...statusGroups["final step"]
];
// Update the filteredCandidates logic to filter by status
const filteredCandidates = React.useMemo(() => {
  let periodFiltered = filterCandidatesByPeriod(candidates);
  
  // Filter by status
  if (selectedStatus !== 'all') {
    periodFiltered = periodFiltered.filter(candidate => {
      const candidateStatus = candidate.status?.toLowerCase();
      const selectedStatusLower = selectedStatus.toLowerCase();
      
      // Check for exact match or partial match (since statuses might be stored differently)
      return candidateStatus === selectedStatusLower || 
             candidateStatus?.includes(selectedStatusLower) ||
             selectedStatusLower.includes(candidateStatus);
    });
  }
  
  // Search filter
  if (searchTerm) {
    const searchLower = searchTerm.toLowerCase();
    periodFiltered = periodFiltered.filter(candidate => {
      return (
        candidate.candidateName?.toLowerCase().includes(searchLower) ||
        candidate.officialEmail?.toLowerCase().includes(searchLower) ||
        candidate.phoneNo?.includes(searchTerm) ||
        candidate.whatsappNo?.includes(searchTerm) ||
        candidate.registrationNumber?.toLowerCase().includes(searchLower) ||
        candidate.pancard?.toLowerCase().includes(searchLower) ||
        candidate.passportNumber?.toLowerCase().includes(searchLower) ||
        candidate.status?.toLowerCase().includes(searchLower)
      );
    });
  }
  
  return periodFiltered;
}, [candidates, searchTerm, selectedPeriod, selectedStatus]);

// const filteredCandidates = React.useMemo(() => {
//   let periodFiltered = filterCandidatesByPeriod(candidates);
//   if (selectedStatus !== 'all') {
//     periodFiltered = periodFiltered.filter(candidate => 
//       candidate.status === selectedStatus
//     );
//   }
  
//   if (searchTerm) {
//     const searchLower = searchTerm.toLowerCase();
//     periodFiltered = periodFiltered.filter(candidate => {
//       return (
//         candidate.candidateName?.toLowerCase().includes(searchLower) ||
//         candidate.officialEmail?.toLowerCase().includes(searchLower) ||
//         candidate.phoneNo?.includes(searchTerm) ||
//         candidate.whatsappNo?.includes(searchTerm) ||
//         candidate.registrationNumber?.toLowerCase().includes(searchLower) ||
//         candidate.pancard?.toLowerCase().includes(searchLower) ||
//         candidate.passportNumber?.toLowerCase().includes(searchLower) ||
//         candidate.status?.toLowerCase().includes(searchLower) // Add this line to search by status
//       );
//     });
//   }
  
//   return periodFiltered;
// }, [candidates, searchTerm, selectedPeriod, selectedStatus]); // Add selectedStatus to dependencies


// console.log('filteredCandidates1111111111111111', filteredCandidates);

// The rest of your sorting and pagination logic can remain the same:
const sortedCandidates = React.useMemo(() => {
  return [...filteredCandidates].sort((a, b) => {
    if (orderBy === 'createdAt' || orderBy === 'dateOfBirth' || 
        orderBy === 'passportIssueDate' || orderBy === 'passportExpiryDate') {
      return order === 'asc' 
        ? new Date(a[orderBy]) - new Date(b[orderBy])
        : new Date(b[orderBy]) - new Date(a[orderBy]);
    }
    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
    return 0;
  });
}, [filteredCandidates, order, orderBy]);

const paginatedCandidates = React.useMemo(() => {
  return sortedCandidates.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
}, [sortedCandidates, page, rowsPerPage]);



  // Loading and error states
  if (loading && candidates.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" p={3}>
        <ErrorOutlineIcon color="error" style={{ fontSize: 60 }} />
        <Typography variant="h6" color="error" mt={2}>{error}</Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={fetchCandidates}
          sx={{ mt: 3 }}
        >
          Retry
        </Button>
      </Box>
    );
  }

// new

const ViewDetailsDialog = ({ open, onClose, candidate }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomDialogOpen, setZoomDialogOpen] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  if (!candidate) return null;

  // Function to get file URL
  const getFileUrl = (filePath) => {
    if (!filePath) return null;
    
    const filename = filePath.split('/').pop();
    if (filePath.includes('profile')) {
      return `${baseUrl}/profile/${filename}`;
    } else if (filePath.includes('attachments')) {
      return `${baseUrl}/file/${filename}`;
    }
    return filePath;
  };

  const downloadFile = async (filePath, fileName) => {
    const url = getFileUrl(filePath);
    if (!url) return;

    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName || filePath.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href); // cleanup
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // Helper function to format phone numbers
  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    
    // Remove all non-digit characters
    const cleaned = phoneNumber.replace(/\D/g, '');
    
    // If number is 10 digits (Indian number without country code)
    if (cleaned.length === 10) {
      return `+91${cleaned}`;
    }
    
    // If number already has 91 prefix (12 digits total)
    if (cleaned.length === 12 && cleaned.startsWith('91')) {
      return `+${cleaned}`;
    }
    
    // For other cases, return original with +91 prefix
    return `+91${cleaned}`;
  };

  // Helper function to convert image to base64
  const getBase64Image = (imgUrl) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/jpeg');
        resolve(dataURL);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = imgUrl;
    });
  };

  //correct

const exportToPDF = async () => {
  setIsGeneratingPDF(true);
  
  try {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 20;
    let yPosition = margin;
    
    // Updated color palette to match UI theme
    const colors = {
      primary: [75, 182, 72],     // #4BB648 - Main green from UI
      primaryDark: [61, 139, 58], // #3D8B3A - Darker green for hover states
      accent: [255, 145, 0],      // Vibrant orange for accents
      light: [250, 250, 250],     // Very light gray
      medium: [100, 100, 100],    // Medium gray
      dark: [40, 40, 40],         // Dark gray
      success: [75, 182, 72],     // Same as primary for consistency
      border: [220, 220, 220]     // Light border
    };
    
    // Format currency with rupee symbol
    const formatCurrencyWithRupee = (amount) => {
      console.log('amount' , amount)
      if (!amount) return '₹0';
      return `Rs. ${new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount)}`;
    };
    
    // Add company logo to header
    const addCompanyLogo = async () => {
      try {
        // Using the provided logo URL
        // const logoUrl = ; // Update with actual logo path
        const logoData = await getBase64Image(logoUrl);
        
        // Add logo to the left side of the header
        pdf.addImage(logoData, 'JPEG', margin, 10, 30, 10);
        
        return true;
      } catch (error) {
        console.error('Error loading company logo:', error);
        
        // Fallback: Add a simple placeholder with company name
        pdf.setFillColor(...colors.primary);
        pdf.rect(margin, 10, 30, 10, 'F');
        pdf.setFontSize(8);
        pdf.setTextColor(255, 255, 255);
        pdf.text('LOGO', margin + 8, 16);
        
        return false;
      }
    };
    
    // Add minimalist header with updated colors and company logo
    const addHeader = async () => {
      // Top accent line using primary green
      pdf.setFillColor(...colors.primary);
      pdf.rect(0, 0, pageWidth, 3, 'F');
      
      // Add company logo
      const logoLoaded = await addCompanyLogo();
      
      // Company name and document title
      pdf.setFontSize(16);
      pdf.setFont(undefined, 'bold');
      pdf.setTextColor(...colors.primary);
      pdf.text('Elixir Care', margin + 35, 16);
      
      pdf.setFontSize(10);
      pdf.setFont(undefined, 'normal');
      pdf.setTextColor(...colors.medium);
      pdf.text('Healthcare Consultancy', margin + 35, 21);
      
      // Document title
      pdf.setFontSize(18);
      pdf.setFont(undefined, 'bold');
      pdf.setTextColor(...colors.primary);
      pdf.text('Candidate Report', pageWidth - margin, 16, { align: 'right' });
      
      // Date and reference
      pdf.setFontSize(9);
      pdf.setTextColor(...colors.medium);
      pdf.text(`Generated: ${new Date().toLocaleDateString()}`, pageWidth - margin, 22, { align: 'right' });
      pdf.text(`Ref: ${candidate.registrationNumber}`, pageWidth - margin, 27, { align: 'right' });
      
      return 35;
    };
    
    // Add section with updated colors
    const addSection = (title, yPos) => {
      // Section title with primary green
      pdf.setFontSize(12);
      pdf.setFont(undefined, 'bold');
      pdf.setTextColor(...colors.primary);
      pdf.text(title, margin, yPos);
      
      // Accent line using primary green
      pdf.setDrawColor(...colors.primary);
      pdf.setLineWidth(0.5);
      pdf.line(margin, yPos + 3, margin + 40, yPos + 3);
      
      // Reset
      pdf.setFont(undefined, 'normal');
      return yPos + 12;
    };
    
    // Add data row with clean layout
    const addDataRow = (label, value, yPos) => {
      pdf.setFontSize(9);
      pdf.setTextColor(...colors.medium);
      pdf.text(label, margin, yPos);
      
      pdf.setFontSize(10);
      pdf.setTextColor(...colors.dark);
      pdf.text(value || 'N/A', margin + 40, yPos);
      
      return yPos + 6;
    };
    
    // Add two-column data row
    const addTwoColumnRow = (label1, value1, label2, value2, yPos) => {
      const midPoint = pageWidth / 2;
      
      // Left column
      pdf.setFontSize(9);
      pdf.setTextColor(...colors.medium);
      pdf.text(label1, margin, yPos);
      
      pdf.setFontSize(10);
      pdf.setTextColor(...colors.dark);
      pdf.text(value1 || 'N/A', margin + 40, yPos);
      
      // Right column
      pdf.setFontSize(9);
      pdf.setTextColor(...colors.medium);
      pdf.text(label2, midPoint, yPos);
      
      pdf.setFontSize(10);
      pdf.setTextColor(...colors.dark);
      pdf.text(value2 || 'N/A', midPoint + 40, yPos);
      
      return yPos + 6;
    };
    
    // Add financial summary with updated colors
    const addFinancialSummary = (yPos) => {
      // Card background
      pdf.setFillColor(...colors.light);
      pdf.rect(margin - 5, yPos - 5, pageWidth - 2 * margin + 2, 55, 'F');
      
      // Card header using primary green
      pdf.setFontSize(11);
      pdf.setFont(undefined, 'bold');
      pdf.setTextColor(...colors.primary);
      // pdf.text('Financial Summary', margin, yPos + 5);
      
      // Financial data in two columns
      const fees = [
        { label: 'Total Fees', value: formatCurrencyWithRupee(candidate.totalProcessingFees) },
        { label: '1st Installment', value: formatCurrencyWithRupee(candidate.firstInstallmentPaid) },
        { label: '2nd Installment', value: formatCurrencyWithRupee(candidate.secondInstallmentPaid) },
        { label: '3rd Installment', value: formatCurrencyWithRupee(candidate.thirdInstallmentPaid) },
        { label: 'Total Paid', value: formatCurrencyWithRupee(candidate.totalPaid) },
        { label: 'Balance', value: formatCurrencyWithRupee(candidate.balance) }
      ];
      
      let currentY = yPos + 15;
      fees.forEach((fee, index) => {
        if (index % 2 === 0) {
          // Left column
          pdf.setFontSize(9);
          pdf.setTextColor(...colors.medium);
          pdf.text(fee.label, margin, currentY);
          
          pdf.setFontSize(10);
          pdf.setTextColor(...colors.dark);
          pdf.text(fee.value, margin + 40, currentY);
        } else {
          // Right column
          const midPoint = pageWidth / 2;
          pdf.setFontSize(9);
          pdf.setTextColor(...colors.medium);
          pdf.text(fee.label, midPoint, currentY);
          
          pdf.setFontSize(10);
          pdf.setTextColor(...colors.dark);
          pdf.text(fee.value, midPoint + 40, currentY);
          
          currentY += 6;
        }
      });
      
      // Card border
      pdf.setDrawColor(...colors.border);
      pdf.setLineWidth(0.3);
      pdf.rect(margin - 5, yPos - 5, pageWidth - 2 * margin + 10, 55);
      
      return yPos + 60;
    };
    
    // Add profile section with updated colors
    const addProfileSection = async (yPos) => {
      // Profile card
      pdf.setFillColor(...colors.light);
      pdf.rect(margin - 5, yPos - 5, pageWidth - 2 * margin + 10, 40, 'F');
      
      try {
        if (candidate.profileImage) {
          const imgData = await getBase64Image(getFileUrl(candidate.profileImage));
          // Simple square image
          pdf.addImage(imgData, 'JPEG', margin, yPos, 25, 25);
        } else {
          // Minimalist placeholder using primary green
          pdf.setFillColor(...colors.primary);
          pdf.rect(margin, yPos, 25, 25, 'F');
          pdf.setFontSize(10);
          pdf.setTextColor(255, 255, 255);
          pdf.text('👤', margin + 7, yPos + 15);
        }
      } catch (error) {
        console.error('Error loading profile image:', error);
      }
      
      // Candidate name with primary green
      pdf.setFontSize(14);
      pdf.setFont(undefined, 'bold');
      pdf.setTextColor(...colors.primary);
      pdf.text(candidate.candidateName, margin + 30, yPos + 8);
      
      // Candidate details
      pdf.setFontSize(9);
      pdf.setFont(undefined, 'normal');
      pdf.setTextColor(...colors.dark);
      pdf.text(`Reg No: ${candidate.registrationNumber}`, margin + 30, yPos + 18);
      pdf.text(`${candidate.gender} | ${candidate.educationCategory} | ${candidate.professionalCategory}`, margin + 30, yPos + 25);
      
      // Card border
      pdf.setDrawColor(...colors.border);
      pdf.setLineWidth(0.3);
      pdf.rect(margin - 5, yPos - 5, pageWidth - 2 * margin + 10, 40);
      
      return yPos + 45;
    };
    
    // Add minimalist footer with updated colors and company name
    const addFooter = (pageNum) => {
      const footerY = pageHeight - 15;
      
      // Footer line using primary green
      pdf.setDrawColor(...colors.primary);
      pdf.setLineWidth(0.3);
      pdf.line(margin, footerY, pageWidth - margin, footerY);
      
      // Footer content with company name
      pdf.setFontSize(8);
      pdf.setTextColor(...colors.medium);
      pdf.text('© 2023 Elixir Care Healthcare Consultancy', margin, footerY + 5);
      pdf.text('www.elixircare.com | info@elixircare.com', pageWidth / 2, footerY + 5, { align: 'center' });
      pdf.text(`Page ${pageNum}`, pageWidth - margin, footerY + 5, { align: 'right' });
    };
    
    // Start building the PDF
    yPosition = await addHeader();
    
    // Profile section (now awaited)
    yPosition = await addProfileSection(yPosition);
    
    // Personal Information Section
    yPosition = addSection('Personal Information', yPosition);
    yPosition = addDataRow('Full Name', candidate.candidateName, yPosition);
    yPosition = addDataRow('Date of Birth', formatDate(candidate.dateOfBirth), yPosition);
    yPosition = addDataRow('Gender', candidate.gender, yPosition);
    yPosition = addDataRow('Passport Number', candidate.passportNumber, yPosition);
    yPosition = addTwoColumnRow('Passport Issue Date', formatDate(candidate.passportIssueDate), 
                               'Passport Expiry Date', formatDate(candidate.passportExpiryDate), yPosition);
    
    // Contact Details Section
    yPosition = addSection('Contact Details', yPosition);
    yPosition = addDataRow('Email', candidate.officialEmail, yPosition);
    yPosition = addTwoColumnRow('Phone', formatPhoneNumber(candidate.phoneNo), 
                               'WhatsApp', formatPhoneNumber(candidate.whatsappNo), yPosition);
    
    // Qualification & License Section
    yPosition = addSection('Qualification & License', yPosition);
    yPosition = addDataRow('Education', candidate.educationCategory, yPosition);
    yPosition = addDataRow('Professional Category', candidate.professionalCategory, yPosition);
    yPosition = addTwoColumnRow('License Category', candidate.licenseCategory, 
                               'Processed By', candidate.licenseProcessedBy, yPosition);
    
    // Financial Details Section
    yPosition = addSection('Financial Details', yPosition);
    yPosition = addFinancialSummary(yPosition);
    
    // Administrative Section
    yPosition = addSection('Administrative Information', yPosition);
    yPosition = addDataRow('Registered By', candidate.registeredBy || 'Not provided', yPosition);
    yPosition = addDataRow('Registration Date', formatDate(candidate.createdAt), yPosition);
    yPosition = addDataRow('Referred By', candidate.referredBy || 'Not provided', yPosition);
    yPosition = addDataRow('Remarks', candidate.remarks || 'No remarks', yPosition);
    
    // Attachments Section (if any)
    if (candidate.attachments && candidate.attachments.length > 0) {
      // Check if we need a new page
      if (yPosition > pageHeight - 40) {
        pdf.addPage();
        yPosition = margin;
        await addHeader();
      }
      
      yPosition = addSection('Attachments', yPosition);
      
      candidate.attachments.forEach((file, index) => {
        const fileName = file.split('/').pop();
        yPosition = addDataRow(`File ${index + 1}`, fileName, yPosition);
        
        // Check if we need a new page
        if (yPosition > pageHeight - 30) {
          pdf.addPage();
          yPosition = margin;
          addHeader();
        }
      });
    }
    
    // Add footers to all pages
    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      addFooter(i);
    }
    
    // Save the PDF
    pdf.save(`candidate_${candidate.registrationNumber}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
  } finally {
    setIsGeneratingPDF(false);
  }
};


  return (
    <>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="lg" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 15px 40px rgba(0,0,0,0.2)',
            maxHeight: '90vh'
          }
        }}
      >
        {/* Header */}
        <DialogTitle sx={{ 
          bgcolor: '#4BB648', 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          py: 2.5,
          borderBottom: '1px solid rgba(255,255,255,0.2)'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <VisibilityIcon fontSize="medium" />
            <Box component="div" sx={{ 
              fontWeight: 600,
              margin: 0,
              ml: 1.5,
              fontSize: '1.25rem'
            }}>
              Candidate Details
            </Box>
            <Chip 
              label={candidate.registrationNumber} 
              sx={{ 
                ml: 2, 
                bgcolor: 'rgba(255,255,255,0.2)', 
                color: 'white',
                fontWeight: 500
              }} 
            />
          </Box>
          <IconButton 
            onClick={onClose} 
            sx={{ 
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        
        <DialogContent sx={{ 
          pt: 4,
          pb: 0,
          bgcolor: '#f9f9f9'
        }}>
          {/* Profile Header with Image */}
          <Paper elevation={0} sx={{ 
            borderRadius: 3,
            p: 3,
            mb: 3,
            bgcolor: 'white',
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <Avatar
              src={getFileUrl(candidate.profileImage)}
              sx={{ 
                width: 100, 
                height: 100, 
                mr: 3,
                cursor: candidate.profileImage ? 'pointer' : 'default',
                '&:hover': candidate.profileImage ? { opacity: 0.8 } : {}
              }}
              onClick={() => {
                if (candidate.profileImage) {
                  setSelectedImage(getFileUrl(candidate.profileImage));
                  setZoomDialogOpen(true);
                }
              }}
            >
              {candidate.candidateName ? candidate.candidateName.charAt(0) : 'C'}
            </Avatar>
            <Box>
              <Typography variant="h5" fontWeight="600" gutterBottom>
                {candidate.candidateName}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                <Chip label={candidate.gender} size="small" variant="outlined" />
                <Chip label={candidate.educationCategory} size="small" variant="outlined" />
                <Chip label={candidate.professionalCategory} size="small" variant="outlined" />
              </Box>
            </Box>
          </Paper>

          {/* Personal Information Section */}
          <Paper elevation={0} sx={{ 
            borderRadius: 3,
            p: 3,
            mb: 3,
            bgcolor: 'white',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <SectionHeader icon={<PersonIcon color="primary" />} title="Personal Information" />
            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' },
              gap: 4
            }}>
              <Box>
                <DetailItem label="Registration No" value={candidate.registrationNumber} />
                <DetailItem label="Full Name" value={candidate.candidateName} />
                <DetailItem label="Date of Birth" value={formatDate(candidate.dateOfBirth)} />
              </Box>
              <Box>
                <DetailItem label="Gender" value={candidate.gender} />
                <DetailItem label="Passport No" value={candidate.passportNumber} />
              </Box>
              <Box>
                <DetailItem label="Passport Issue" value={formatDate(candidate.passportIssueDate)} />
                <DetailItem label="Passport Expiry" value={formatDate(candidate.passportExpiryDate)} />
              </Box>
            </Box>
          </Paper>

          {/* Contact Details Section */}
          <Paper elevation={0} sx={{ 
            borderRadius: 3,
            p: 3,
            mb: 3,
            bgcolor: 'white',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <SectionHeader icon={<ContactMailIcon color="primary" />} title="Contact Details" />
            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              gap: 4
            }}>
              <Box>
                <DetailItem label="Email" value={candidate.officialEmail} />
                <DetailItem label="Phone" value={formatPhoneNumber(candidate.phoneNo)} />
              </Box>
              <Box>
                <DetailItem label="WhatsApp" value={formatPhoneNumber(candidate.whatsappNo)} />
              </Box>
            </Box>
          </Paper>

          {/* Qualification & License Section */}
          <Paper elevation={0} sx={{ 
            borderRadius: 3,
            p: 3,
            mb: 3,
            bgcolor: 'white',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <SectionHeader icon={<SchoolIcon color="primary" />} title="Qualification & License" />
            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              gap: 4
            }}>
              <Box>
                <DetailItem label="Education" value={candidate.educationCategory} />
                <DetailItem label="Professional Category" value={candidate.professionalCategory} />
              </Box>
              <Box>
                <DetailItem label="License Category" value={candidate.licenseCategory} />
                <DetailItem label="Processed By" value={candidate.licenseProcessedBy} />
              </Box>
            </Box>
          </Paper>

          {/* Financial Details Section */}
          <Paper elevation={0} sx={{ 
            borderRadius: 3,
            p: 3,
            mb: 3,
            bgcolor: 'white',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <SectionHeader icon={<AttachMoneyIcon color="primary" />} title="Financial Details" />
            
            <Box sx={{ 
              display: 'grid', 
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' },
              gap: 2, 
              mb: 4 
            }}>
              <Paper elevation={0} sx={{ p: 2, bgcolor: '#f0f7ff', borderRadius: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Total Fees
                </Typography>
                <Typography variant="h6" fontWeight="600">
                  {formatCurrency(candidate.totalProcessingFees)}
                </Typography>
              </Paper>
              
              <Paper elevation={0} sx={{ p: 2, bgcolor: '#f0f9f0', borderRadius: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Total Paid
                </Typography>
                <Typography variant="h6" fontWeight="600" color="#4BB648">
                  {formatCurrency(candidate.totalPaid)}
                </Typography>
              </Paper>
              
              <Paper elevation={0} sx={{ p: 2, bgcolor: '#fff5f5', borderRadius: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Balance
                </Typography>
                <Typography 
                  variant="h6" 
                  fontWeight="600" 
                  color={candidate.balance > 0 ? 'error.main' : '#4BB648'}
                >
                  {formatCurrency(candidate.balance)}
                </Typography>
              </Paper>
              
              <Paper elevation={0} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Payment Status
                </Typography>
                <Chip 
                  label={candidate.balance > 0 ? 'Pending' : 'Paid'} 
                  color={candidate.balance > 0 ? 'warning' : 'success'} 
                  size="small" 
                />
              </Paper>
            </Box>
            
            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              gap: 4
            }}>
              <Box>
                <DetailItem label="Total Fees" value={formatCurrency(candidate.totalProcessingFees)} />
                <DetailItem label="1st Installment" value={formatCurrency(candidate.firstInstallmentPaid)} />
                <DetailItem label="2nd Installment" value={formatCurrency(candidate.secondInstallmentPaid)} />
              </Box>
              <Box>
                <DetailItem label="3rd Installment" value={formatCurrency(candidate.thirdInstallmentPaid)} />
                <DetailItem 
                  label="Balance" 
                  value={formatCurrency(candidate.balance)} 
                  valueColor={candidate.balance > 0 ? 'error' : '#4BB648'}
                />
              </Box>
            </Box>
          </Paper>

          {/* Admin Section */}
          <Paper elevation={0} sx={{ 
            borderRadius: 3,
            p: 3,
            mb: 3,
            bgcolor: 'white',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <SectionHeader icon={<AdminPanelSettingsIcon color="primary" />} title="Administrative" />
            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              gap: 4
            }}>
              <Box>
                <DetailItem label="Registered By" value={candidate.registeredBy || 'Not provided'} />
                <DetailItem label="Registration Date" value={formatDate(candidate.createdAt)} />
              </Box>
              <Box>
                <DetailItem label="Referred By" value={candidate.referredBy} />
                <DetailItem label="Remarks" value={candidate.remarks} />
              </Box>
            </Box>
          </Paper>

          {/* Attachments Section */}
          <Paper elevation={0} sx={{ 
            borderRadius: 3,
            p: 3,
            mb: 3,
            bgcolor: 'white',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <SectionHeader icon={<AttachmentIcon color="primary" />} title="Attachments" />
            
            {candidate.attachments && candidate.attachments.length > 0 ? (
              <Grid container spacing={2}>
                {candidate.attachments.map((file, index) => {
                  const fileUrl = getFileUrl(file);
                  const fileName = file.split('/').pop();
                  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName);
                  const fileExtension = fileName.split('.').pop().toUpperCase();
                  
                  return (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card sx={{ 
                        height: '100%', 
                        display: 'flex', 
                        flexDirection: 'column',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 6px 12px rgba(0,0,0,0.15)'
                        }
                      }}>
                        {/* Image/File Preview */}
                        <Box 
                          sx={{ 
                            position: 'relative',
                            height: 180,
                            overflow: 'hidden',
                            cursor: isImage ? 'pointer' : 'default',
                            bgcolor: isImage ? 'transparent' : '#f5f5f5'
                          }}
                          onClick={() => {
                            if (isImage) {
                              setSelectedImage(fileUrl);
                              setZoomDialogOpen(true);
                            }
                          }}
                        >
                          {isImage ? (
                            <img
                              src={fileUrl}
                              alt={fileName}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease'
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'scale(1.05)';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                              }}
                              onError={(e) => {
                                e.target.src = '/placeholder-image.png';
                              }}
                            />
                          ) : (
                            <Box sx={{ 
                              height: '100%', 
                              display: 'flex', 
                              flexDirection: 'column',
                              alignItems: 'center', 
                              justifyContent: 'center',
                              color: 'text.secondary'
                            }}>
                              <DescriptionIcon sx={{ fontSize: 48, mb: 1 }} />
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {fileExtension} File
                              </Typography>
                            </Box>
                          )}
                          
                          {/* Image overlay with view button */}
                          {isImage && (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                bgcolor: 'rgba(0,0,0,0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: 0,
                                transition: 'opacity 0.3s ease',
                                '&:hover': {
                                  opacity: 1
                                }
                              }}
                            >
                              <IconButton 
                                sx={{ 
                                  color: 'white',
                                  bgcolor: 'rgba(0,0,0,0.5)',
                                  '&:hover': {
                                    bgcolor: 'rgba(0,0,0,0.7)'
                                  }
                                }}
                                onClick={() => {
                                  setSelectedImage(fileUrl);
                                  setZoomDialogOpen(true);
                                }}
                              >
                                <ZoomInIcon />
                              </IconButton>
                            </Box>
                          )}
                        </Box>
                        
                        {/* File info and actions */}
                        <CardContent sx={{ p: 2, flexGrow: 1 }}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontWeight: 500,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical'
                            }}
                            title={fileName}
                          >
                            {fileName}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {isImage ? 'Image' : 'Document'} • {index + 1}
                          </Typography>
                        </CardContent>
                        
                        <CardActions sx={{ p: 1, pt: 0 }}>
                          <Button
                            size="small"
                            startIcon={<DownloadIcon />}
                            onClick={() => downloadFile(file, fileName)}
                            sx={{ mr: 1 }}
                          >
                            Download
                          </Button>
                          {isImage && (
                            <Button
                              size="small"
                              startIcon={<ZoomInIcon />}
                              onClick={() => {
                                setSelectedImage(fileUrl);
                                setZoomDialogOpen(true);
                              }}
                            >
                              View
                            </Button>
                          )}
                        </CardActions>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <AttachmentIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
                <Typography variant="body1" color="text.secondary">
                  No documents attached
                </Typography>
              </Box>
            )}
          </Paper>
        </DialogContent>
        
        <DialogActions sx={{ 
          p: 2.5,
          bgcolor: '#f9f9f9',
          borderTop: '1px solid #e0e0e0'
        }}>
          <Button 
            onClick={exportToPDF}
            disabled={isGeneratingPDF}
            variant="outlined"
            sx={{
              color: 'text.secondary',
              borderColor: 'text.secondary',
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              mr: 2
            }}
            startIcon={isGeneratingPDF ? <CircularProgress size={20} /> : <FileDownloadIcon />}
          >
            {isGeneratingPDF ? 'Generating...' : 'Export to PDF'}
          </Button>
          <Button 
            onClick={onClose}
            variant="outlined"
            sx={{
              color: 'text.secondary',
              borderColor: 'text.secondary',
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              mr: 2
            }}
          >
            Close
          </Button>
          <Button 
            variant="contained"
            sx={{
              bgcolor: '#4BB648',
              color: 'white',
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              '&:hover': {
                bgcolor: '#3D8B3A',
                boxShadow: '0 4px 12px rgba(61, 139, 58, 0.3)'
              }
            }}
            startIcon={<CheckIcon />}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image Zoom Dialog */}
      <Dialog 
        open={zoomDialogOpen} 
        onClose={() => setZoomDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          View Image
          <IconButton
            aria-label="close"
            onClick={() => setZoomDialogOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Enlarged view"
              style={{ width: '100%', height: 'auto' }}
              onError={(e) => {
                e.target.src = '/placeholder-image.png';
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const SectionHeader = ({ icon, title }) => (
  <Box sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    mb: 3,
    pb: 2,
    borderBottom: '2px solid rgba(0,0,0,0.08)'
  }}>
    <Box sx={{ mr: 1.5, display: 'flex' }}>{icon}</Box>
    <Typography variant="h6" fontWeight="600" color="text.primary">
      {title}
    </Typography>
  </Box>
);

const DetailItem = ({ label, value, valueColor }) => (
  <Box sx={{ mb: 2 }}>
    <Typography 
      variant="caption" 
      sx={{ 
        display: 'block',
        color: 'text.secondary',
        fontSize: '0.75rem',
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}
    >
      {label}
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontWeight: 500,
        color: valueColor || 'text.primary',
        wordBreak: 'break-word',
        fontSize: '0.95rem',
        mt: 0.5
      }}
    >
      {value || <span style={{ color: '#999', fontStyle: 'italic' }}>Not provided</span>}
    </Typography>
  </Box>
);

  return (
    <Paper elevation={0} sx={{ 
      borderRadius: 3,
      overflow: 'hidden',
      border: `1px solid ${theme.palette.divider}`,
      marginTop: '79px',
      width: '100%',
      
    }}>

    <Box
  sx={{
    p: 2,
    borderBottom: `1px solid ${theme.palette.divider}`,

    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  }}
>
  {/* HEADER */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 2,
    }}
  >
    <Box>
      <Typography variant="h5" component="h1" fontWeight="600">
        Candidate List
      </Typography>
      <Typography
        variant="body2"
        sx={{ opacity: 0.8, mt: 0.5, color: theme.palette.text.secondary }}
      >
        {filteredCandidates.length} candidate(s) found
      </Typography>
    </Box>

    <Box
      display="flex"
      gap={1}
      sx={{
        width: { xs: "100%", sm: "auto" },
        mt: { xs: 2, sm: 0 },
      }}
    >


  <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
  <FormControl size="small" sx={{ minWidth: 200 }}>
    <InputLabel>Filter by Status</InputLabel>
    <Select
      value={selectedStatus}
      onChange={(e) => setSelectedStatus(e.target.value)}
      label="Filter by Status"
    >
      <MenuItem value="all">All Status</MenuItem>
      
      {/* Online Class Group */}
      <MenuItem disabled sx={{ fontWeight: 'bold', opacity: 0.7 }}>
        ─ ONLINE CLASS ─
      </MenuItem>
      {statusGroups["online class"].map(status => (
        <MenuItem key={status} value={status} sx={{ pl: 4 }}>
          {status}
        </MenuItem>
      ))}
      
      {/* Dataflow Group */}
      <MenuItem disabled sx={{ fontWeight: 'bold', opacity: 0.7, mt: 1 }}>
        ─ DATAFLOW ─
      </MenuItem>
      {statusGroups["dataflow"].map(status => (
        <MenuItem key={status} value={status} sx={{ pl: 4 }}>
          {status}
        </MenuItem>
      ))}
      
      {/* Exam Booking Group */}
      <MenuItem disabled sx={{ fontWeight: 'bold', opacity: 0.7, mt: 1 }}>
        ─ EXAM BOOKING ─
      </MenuItem>
      {statusGroups["exam booking"].map(status => (
        <MenuItem key={status} value={status} sx={{ pl: 4 }}>
          {status}
        </MenuItem>
      ))}
      
      {/* Others Group */}
      <MenuItem disabled sx={{ fontWeight: 'bold', opacity: 0.7, mt: 1 }}>
        ─ OTHERS ─
      </MenuItem>
      {statusGroups["others"].map(status => (
        <MenuItem key={status} value={status} sx={{ pl: 4 }}>
          {status}
        </MenuItem>
      ))}
      
      {/* Final Step Group */}
      <MenuItem disabled sx={{ fontWeight: 'bold', opacity: 0.7, mt: 1 }}>
        ─ FINAL STEP ─
      </MenuItem>
      {statusGroups["final step"].map(status => (
        <MenuItem key={status} value={status} sx={{ pl: 4 }}>
          {status}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>
 
    <Box
    sx={{
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 2,
    }}
  >
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <InputLabel>Filter by Period</InputLabel>
      <Select
        value={selectedPeriod}
        onChange={(e) => setSelectedPeriod(e.target.value)}
        label="Filter by Period"
      >
        <MenuItem value="all">All Time</MenuItem>
        <MenuItem value="today">Today</MenuItem>
        <MenuItem value="yesterday">Yesterday</MenuItem>
        <MenuItem value="thisWeek">This Week</MenuItem>
        <MenuItem value="lastWeek">Last Week</MenuItem>
        <MenuItem value="thisMonth">This Month</MenuItem>
        <MenuItem value="lastMonth">Last Month</MenuItem>
        <MenuItem value="thisYear">This Year</MenuItem>
      </Select>
    </FormControl>
  </Box>

      <TextField
        variant="outlined"
        placeholder="Search candidates..."
        size="small"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          sx: {
            bgcolor: theme.palette.background.default,
            borderRadius: 1,
          },
        }}
        sx={{
          flex: 1,
          minWidth: 200,
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
              borderColor: theme.palette.primary.main,
            },
          },
        }}
      />

      <Button
        variant="contained"
        startIcon={<FileDownloadIcon />}
        onClick={() => setExportDialogOpen(true)}
        sx={{
          bgcolor: "#4BB648",
          color: "#fff",
          "&:hover": {
            bgcolor: "#3A9139",
          },
          whiteSpace: "nowrap",
        }}
      >
        Export Data
      </Button>
    </Box>
  </Box>

</Box>
      <Box sx={{ p: 0.2  }}>
        <TableContainer sx={{ 
          maxHeight: 'calc(100vh - 300px)',
          overflow: 'auto',
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
        }}>
          <Table stickyHeader size="medium" sx={{ minWidth: 1200 }}>
            <TableHead>
              <TableRow>
                {[
                  { id: 'registrationNumber', label: 'Reg No', width: '15%' },
                  { id: 'candidate Details', label: 'Name', width: '25%' },
                  // { id: 'officialEmail', label: 'Email', width: '13%' },
                  // { id: 'phoneNo', label: 'Phone', width: '10%' },
                  { id: 'totalProcessingFees', label: 'Total Fees', width: '10%' },
                  { id: 'totalPaid', label: 'Paid', width: '10%' },
                  { id: 'balance', label: 'Balance', width: '10%' },
                  { id: 'first_installment_date', label: 'Registered On', width: '10%' },
                  { id: 'status', label: 'Status', width: '8%' },
                  { id: 'actions', label: 'Actions', width: '8%' },                  

                ].map((headCell) => (
                  <TableCell 
                    key={headCell.id}
                    sortDirection={orderBy === headCell.id ? order : false}
                    sx={{ 
                      fontWeight: 600,
                      bgcolor: '#f5f5f5',
                      width: headCell.width
                    }}
                  >
                    {headCell.id !== 'actions' ? (
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={() => handleRequestSort(headCell.id)}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    ) : (
                      headCell.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedCandidates.length > 0 ? (
                paginatedCandidates.map((candidate) => (
                  <StyledTableRow key={candidate._id} hover>
                    <TableCell>
                      <Typography variant="body2" fontWeight="500">
                        {candidate.registrationNumber}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="flex-start" gap={1} flexDirection="column">
                       
                        <Typography fontWeight="500">
                          {candidate.candidateName}                          
                        </Typography>
                        <span >
                          {candidate.officialEmail}
                          </span>
                      </Box>
                    </TableCell>
                    {/* <TableCell>
                      <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                        {candidate.officialEmail}
                      </Typography>
                    </TableCell>                    */}
                    <TableCell>
                      <Typography fontWeight="500">
                        {formatCurrency(candidate.totalProcessingFees)}
                      </Typography>
                    </TableCell>

                     <TableCell>
                      <Typography fontWeight="500">
                        {formatCurrency(candidate.totalPaid)}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Typography 
                        fontWeight="500"
                        color={candidate.balance > 0 ? 'error' : '#4BB648'}
                      >
                        {formatCurrency(candidate.balance)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatDate(candidate.firstInstallmentDate)}
                      </Typography>
                    </TableCell>

                    <TableCell>
  <Chip 
    label={candidate.status || 'No Status'} 
    size="small"
    sx={{
      backgroundColor: getStatusColor(candidate.status),
      color: '#fff',
      fontWeight: 500,
      '& .MuiChip-label': {
        px: 1,
      }
    }}
  />
</TableCell>

                    {/* <TableCell>
  <Chip 
    label={candidate.status || 'No Status'} 
    size="small"
  />
</TableCell> */}
                    <TableCell align="center">
                      <Tooltip title="Actions">
                        <IconButton
                          onClick={(e) => handleMenuClick(e, candidate)}
                          size="small"
                          sx={{
                            '&:hover': {
                              backgroundColor: alpha('#4BB648', 0.1),
                            }
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </StyledTableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                    <Box display="flex" flexDirection="column" alignItems="center">
                      <SearchIcon fontSize="large" color="disabled" />
                      <Typography variant="h6" color="textSecondary" mt={1}>
                        No candidates found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Action Menu */}
               <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleMenuClose}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'right',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
  }}
  PaperProps={{
    elevation: 3,
    sx: {
      minWidth: 180,
      borderRadius: 2,
      py: 0.5,
      '& .MuiMenuItem-root': {
        px: 2,
        py: 1,
        typography: 'body2',
      }
    }
  }}
>
  <MenuItem onClick={() => {
    exportFormattedData([selectedCandidate], `candidate_${selectedCandidate.registrationNumber}`);
    handleMenuClose();
  }}>
    <FileDownloadIcon fontSize="small" sx={{ mr: 1.5, color: 'text.secondary' }} />
    Export
  </MenuItem>

  <MenuItem onClick={handleViewDetails}>
    <VisibilityIcon fontSize="small" sx={{ mr: 1.5, color: 'text.secondary' }} />
    View Details
  </MenuItem>


  <MenuItem onClick={handleEditCandidate}>
    <EditIcon fontSize="small" sx={{ mr: 1.5, color: 'text.secondary' }} />
    Edit
  </MenuItem>
  
  <MenuItem onClick={() => handleDeleteClick(selectedCandidate)}>
    <DeleteIcon fontSize="small" sx={{ mr: 1.5, color: 'error.main' }} />
    <Typography color="error">Delete</Typography>
  </MenuItem>
</Menu>


{/* Attachments Dialog */}
<Dialog 
  open={attachmentDialogOpen} 
  onClose={handleCloseAttachmentDialog}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>
    <Box display="flex" alignItems="center">
      <AttachmentIcon sx={{ mr: 1, color: 'primary.main' }} />
      Attached Files - {selectedCandidate?.candidateName}
    </Box>
  </DialogTitle>
  <DialogContent>
    <Box sx={{ mt: 2 }}>
      {selectedAttachments.length === 0 ? (
        <Typography color="text.secondary" textAlign="center">
          No attachments found for this candidate
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {selectedAttachments.map((attachmentUrl, index) => {
            const fileName = attachmentUrl.split('/').pop();
            const isImage = /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(fileName);
            
            return (
              <Grid item xs={6} sm={4} key={index}>
                <Card 
                  sx={{ 
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: 3
                    }
                  }}
                  onClick={() => handlePreviewAttachment(attachmentUrl)}
                >
                  {isImage ? (
                    <CardMedia
                      component="img"
                      height="140"
                      image={attachmentUrl}
                      alt={`Attachment ${index + 1}`}
                      sx={{ objectFit: 'cover' }}
                    />
                  ) : (
                    <Box sx={{ 
                      height: 140, 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      bgcolor: 'grey.100'
                    }}>
                      <DescriptionIcon sx={{ fontSize: 48, color: 'grey.400' }} />
                    </Box>
                  )}
                  <CardContent sx={{ p: 1 }}>
                    <Typography variant="body2" noWrap title={fileName}>
                      {fileName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {isImage ? 'Image' : 'Document'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseAttachmentDialog}>Close</Button>
  </DialogActions>
</Dialog>

{/* Image Preview Dialog */}
<Dialog 
  open={previewOpen} 
  onClose={handleClosePreview}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: {
      maxHeight: '90vh'
    }
  }}
>
  <DialogTitle>
    File Preview
    <IconButton
      aria-label="close"
      onClick={handleClosePreview}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent>
    {previewAttachment && (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        p: 2
      }}>
        {previewAttachment.match(/\.(jpg|jpeg|png|gif|webp|bmp)$/i) ? (
          <>
            
            <iframe
    src={previewAttachment}
    style={{
      width: '100%',
      height: '500px',
      border: 'none',
      borderRadius: '8px'
    }}
    title="File Preview"
  />
            <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
              <Button 
                variant="contained"
                onClick={() => window.open(previewAttachment, '_blank')}
                startIcon={<DownloadIcon />}
              >
                Download
              </Button>
              <Button 
                variant="outlined"
                onClick={handleClosePreview}
              >
                Close
              </Button>
            </Box>
          </>
        ) : (
          <Box sx={{ textAlign: 'center' }}>
            <DescriptionIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              File Preview Not Available
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              This file type cannot be previewed in the browser.
            </Typography>
            <Button 
              variant="contained" 
              sx={{ mt: 2 }}
              onClick={() => window.open(previewAttachment, '_blank')}
              startIcon={<DownloadIcon />}
            >
              Download File
            </Button>
          </Box>
        )}
      </Box>
    )}
  </DialogContent>
</Dialog>


{selectedCandidate && (
  <ViewDetailsDialog
    open={viewDialogOpen}
    onClose={() => setViewDialogOpen(false)}
    candidate={selectedCandidate}
  />
)}
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ 
            bgcolor: '#4BB648', 
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <DeleteIcon />
            Confirm Delete
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
           <DialogContentText>
  {selectedCandidate 
    ? <>Are you sure you want to delete candidate <strong>{selectedCandidate.candidateName}</strong>? This action cannot be undone.</>
    : "Are you sure you want to delete this candidate?"}
</DialogContentText>

          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button 
              onClick={() => setDeleteDialogOpen(false)} 
              sx={{ color: 'text.secondary', mr: 1 }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleDeleteConfirm} 
              variant="contained"
              color="error"
              sx={{
                '&:hover': {
                  bgcolor: theme.palette.error.dark
                }
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>


        {/* Export Dialog */}
        <ExportDialog
          open={exportDialogOpen}
          onClose={() => setExportDialogOpen(false)}
          onExport={handleExport}
        />


        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredCandidates.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ 
            borderTop: `1px solid ${theme.palette.divider}`, 
            pt: 2,
            '& .MuiTablePagination-toolbar': {
              px: 0
            }
          }}
        />        
        
      </Box>
    </Paper>
  );
};

export default CandidateList;

